export function keepActive(store) {
  store.listen(() => {})
}
